<template>
  <div class="page page-contacts">
    <div class="page-title">Ваша команда</div>

    <div v-if="!loaded" class="loader"></div>

    <div class="alert alert-danger"
         role="alert"
         v-if="error">
      {{error}}
    </div>

    <div v-if="loaded">
      <div class="title">Ваши врачи</div>

      <div
          v-for="(doctor, doctorKey) in doctors"
          :key="'doctor' + doctorKey"
          class="item">
        <div class="avatar">
          <img :src="doctor.image.url" :alt="doctor.name">
        </div>

        <div class="name">{{doctor.name}}</div>

        <div class="bio">{{doctor.description}}</div>

        <div v-if="doctor.phone">
          <a :href="'tg://msg?text=&to=' + doctor.phone">
            <i class="fab fa-telegram mr-2"></i>
            {{doctor.phone}}
          </a>
        </div>

        <div v-if="doctor.email">
          <a :href="'mailto:' + doctor.email">
            <i class="fas fa-at mr-2"></i>
            {{doctor.email}}
          </a>
        </div>

        <div v-if="doctor.phone">
          <a :href="'tel:' + doctor.phone">
            <i class="fas fa-phone mr-2"></i>
            {{doctor.phone}}
          </a>
        </div>
      </div>

      <div class="title">Ваши ассистенты</div>

      <div
          v-for="(assistant, assistantKey) in assistants"
          :key="'assistant' + assistantKey"
          class="item">
        <div class="avatar">
          <img :src="assistant.image.url" :alt="assistant.name">
        </div>

        <div class="name">{{assistant.name}}</div>

        <div class="bio">{{assistant.description}}</div>

        <div v-if="assistant.phone">
          <a :href="'tg://msg?text=&to=' + assistant.phone">
            <i class="fab fa-telegram mr-2"></i>
            {{assistant.phone}}
          </a>
        </div>

        <div>
          <a href="mailto:client@life-plus.online">
            <i class="fas fa-at mr-2"></i>
            client@life-plus.online
          </a>
        </div>

        <div>
          <a href="tel:88004443154">
            <i class="fas fa-phone mr-2"></i>
            8 800 444 3154
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loaded: false,
        error: '',
      };
    },

    created() {
      this.loadData();
    },

    computed: {
      doctors() {
        return this.$store.state.contacts.doctors || [];
      },

      assistants() {
        return this.$store.state.contacts.assistants || [];
      }
    },

    methods: {
      async loadData() {
        this.loaded = false;
        this.error = '';

        try {
          await this.$store.dispatch('LOAD_CONTACTS');
        } catch(e) {
          this.error = 'Произошла ошибка. Повторите попытку позже.';
        }

        this.loaded = true;
      },
    },
  }
</script>

<style lang="scss">
  @import "../assets/scss/variables.scss";

  .page-contacts {
    padding-bottom: 10px;

    .title {
      position: relative;
      padding: 10px 0 10px 20px;
      font-weight: bold;
      font-size: 12px;
      text-transform: uppercase;
      color: $primary;
      border-top: 2px solid $primary;
      border-bottom: 1px solid $primary;
    }

    .item {
      margin: 0 0 20px;
      padding: 10px 20px;
      border-top: 1px solid $primary;

      .avatar {
        max-width: 200px;
        margin: 0 auto 10px;

        img {
          width: 100%;
        }
      }

      .name {
        font-weight: bold;
        font-size: 16px;
        text-align: center;
        color: $primary;
      }

      .bio {
        text-align: justify;
      }

      a {
        color: $primary;
        text-decoration: underline;
      }
    }
  }
</style>
